<template>
    <SelectorProductionDate class="mx-auto mb-1" :wide="true" v-if="by_date_active" />
    <SelectorViewerList class="mx-auto mb-1" v-else />
</template>


<script setup>
import SelectorProductionDate from "@/components/left_menu/SelectorProductionDate.vue";
import SelectorViewerList from "@/components/left_menu/SelectorViewerList.vue";

import { computed } from "vue";
import { useAppStore } from "@/stores/app";

const app_store = useAppStore()

// Which control belongs here is decided by the same flag the list itself is
// filtered with. Deciding it with `companyWide` (or with the user's role) used
// to disagree with `myList`, which branches on `byDateModeActive`: a manager
// company-wide at a company not working by date got the date selector and its
// two switches, all three inert, while the one flag that branch reads was
// unreachable; and a production worker company-wide at a company working by
// date got a "show ready" switch that did nothing.
const by_date_active = computed(() => app_store.byDateModeActive)
</script>
